// React
import React from 'react';
import PropTypes from 'prop-types';
// Locales
import translate from 'locales/i18n';
// Material UI
import {
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
    IconButton,
    TextField,
    Tooltip
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Autocomplete } from '@mui/lab';
// Material UI Icons
import {
    Done as DoneIcon,
    Cancel as CancelIcon
} from '@mui/icons-material';
// Utils
import { countries, countryToFlag } from './DialogEditProxyUtils';

export default function DialogEditProxy(props) {

    // Prop validation
    DialogEditProxy.propTypes = {
        open: PropTypes.bool,
        close: PropTypes.func,
        callbackFunction: PropTypes.func,
        proxy: PropTypes.object,
        title: PropTypes.string
    };

    // Css
    const classes = useStyles();
    const { open, close, callbackFunction, proxy, title } = props;
    // eslint-disable-next-line prefer-const
    let proxyToEdit = JSON.parse(JSON.stringify(proxy));

    const updateProxyValue = (id, value) => {
        switch (id) {
        case 'host':
            proxyToEdit.host = value;
            break;
        case 'type':
            proxyToEdit.type = value;
            break;
        case 'country':
            proxyToEdit.country = value ? value.code : '';
            break;
        case 'provider':
            proxyToEdit.provider = value;
            break;
        case 'login':
            proxyToEdit.login = value;
            break;
        case 'pwd':
            proxyToEdit.pwd = value;
            break;
        default:
        }
    };

    return (
        <Dialog
            open={open}
            onClose={close}
            disableRestoreFocus={true}
            classes={{
                paper: classes.dialogPaperRoot
            }}
            aria-labelledby='responsive-dialog-title'
        >
            <DialogTitle id='responsive-dialog-title'>{title}</DialogTitle>
            <DialogContent>
                { proxyToEdit.id &&
                    <p>Identifiant du proxy en base : {proxyToEdit.id}</p>
                }
                <TextField
                    id='host'
                    defaultValue={proxyToEdit.host}
                    label={translate.i18n('HOST')}
                    onChange={(event) => updateProxyValue(event.target.id, event.target.value)}
                    variant='outlined'
                    classes={{
                        root: classes.textField
                    }}
                />
                <Autocomplete
                    className={classes.textField}
                    defaultValue={proxyToEdit.type}
                    onChange={(event, newValue) => {
                        newValue !== null && updateProxyValue('type', newValue);
                    }}
                    id='type'
                    options={ ['DATACENTER', 'MOBILE', 'RESIDENTIAL'] }
                    renderInput={(params) =>
                        <TextField {...params} label={translate.i18n('TYPE')} variant='outlined' />
                    }
                />
                <TextField
                    id='provider'
                    defaultValue={proxyToEdit.provider}
                    label={translate.i18n('PROVIDER')}
                    onChange={(event) => updateProxyValue(event.target.id, event.target.value)}
                    variant='outlined'
                    classes={{
                        root: classes.textField
                    }}
                />

                <Autocomplete
                    id='country'
                    options={countries}
                    classes={{
                        root: classes.textField
                    }}
                    autoHighlight
                    getOptionLabel={(option) => option.label}
                    renderOption={(option) =>
                        <React.Fragment>
                            <div id='countrySearch' code={option.code} style={{ display: 'block' }}>
                                <span>{countryToFlag(option.code)}</span>
                                {' '} {option.label} ({option.code})
                            </div>
                        </React.Fragment>
                    }
                    value={countries.find(el => el.code === proxyToEdit.country)}
                    onChange={(event, newValue) => {
                        updateProxyValue('country', newValue);
                    }}
                    defaultValue={countries.find(el => el.code === proxyToEdit.country)}
                    renderInput={(params) =>
                        <>
                            <TextField
                                {...params}
                                label={translate.i18n('CHOOSE_COUNTRY')}
                                variant='outlined'
                            />
                        </>
                    }
                />

                <TextField
                    id='login'
                    defaultValue={proxyToEdit.login}
                    label={translate.i18n('LOGIN')}
                    onChange={(event) => updateProxyValue(event.target.id, event.target.value)}
                    variant='outlined'
                    classes={{
                        root: classes.textField
                    }}
                />
                <TextField
                    id='pwd'
                    defaultValue={proxyToEdit.pwd}
                    label={translate.i18n('PASSWORD')}
                    onChange={(event) => updateProxyValue(event.target.id, event.target.value)}
                    variant='outlined'
                    classes={{
                        root: classes.textField
                    }}
                />

            </DialogContent>
            <DialogActions>
                <Tooltip title={translate.i18n('CANCEL')} placement='top'>
                    <IconButton color='secondary' onClick={() => close()}>
                        <CancelIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={translate.i18n('SAVE')} placement='top'>
                    <IconButton color='primary' onClick={() => callbackFunction(proxyToEdit)}>
                        <DoneIcon />
                    </IconButton>
                </Tooltip>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({
    dialogPaperRoot: {
        width: '100%',
        maxWidth: '700px'
    },
    textField: {
        width: '100%',
        margin: '10px 0 10px 0'
    }
}));
